import React from 'react';
import styled from 'styled-components';

type Props = {
  code?: string | null;
  children?: React.ReactNode;
  className?: string;
};

// 서비스 코드별 스타일 매핑
const VARIANTS: Record<string, { bg: string; color: string; border: string }> = {
  '01': { bg: '#f0fbff', color: '#056a9a', border: 'rgba(5,106,154,0.12)' },
  '02': { bg: '#f6f3ff', color: '#5c3ca8', border: 'rgba(92,60,168,0.12)' },
  '03': { bg: '#f3fff8', color: '#0b8a4a', border: 'rgba(11,138,74,0.12)' },
  '04': { bg: '#fffaf0', color: '#c56a00', border: 'rgba(197,106,0,0.12)' },
  '05': { bg: '#fff6f0', color: '#c24b00', border: 'rgba(194,75,0,0.12)' },
  '06': { bg: '#f0f6ff', color: '#1e63b8', border: 'rgba(30,99,184,0.12)' },
  '07': { bg: '#fff5f5', color: '#b32a2a', border: 'rgba(179,42,42,0.12)' },
  '08': { bg: '#f3fff6', color: '#0b8a4a', border: 'rgba(11,138,74,0.12)' },
  '09': { bg: '#f6f8ff', color: '#2267b2', border: 'rgba(34,103,178,0.12)' },
  '10': { bg: '#fff8e6', color: '#a05a00', border: 'rgba(160,90,0,0.12)' },
  '11': { bg: '#faf6ff', color: '#6c47b6', border: 'rgba(108,71,182,0.12)' }
};

const Badge = styled.div<{ bg: string; color: string; border: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  height: 20px;
  min-width: 56px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  box-shadow: 0 1px 0 rgba(16, 24, 40, 0.03);
  background: ${p => p.bg};
  color: ${p => p.color};
  border: 1px solid ${p => p.border};
`;

export default function ServiceBadge({ code, children, className }: Props) {
  const key = (code || '').toString();
  const s = VARIANTS[key] || { bg: '#eef6ff', color: '#388fc0', border: 'rgba(56,143,192,0.12)' };
  return (
    <Badge bg={s.bg} color={s.color} border={s.border} className={className}>
      {children}
    </Badge>
  );
}
